import { ReactChild } from "react";

import "./AdminLayout.css";

import BannerController from "components/BannerController";
import ToastList from "components/toasts/ToastList";

import AdminPageHeader, { AdminPageHeaderProps } from "./AdminPageHeader";

type AdminLayoutProps = AdminPageHeaderProps & {
  children: ReactChild;
};

const AdminLayout = ({
  children,
  navLinks,
  selectedLink,
  logoLink,
}: AdminLayoutProps) => {
  return (
    <>
      <ToastList />
      <div className="AdminLayout">
        <BannerController />
        <AdminPageHeader
          logoLink={logoLink}
          navLinks={navLinks}
          selectedLink={selectedLink}
        />
        <div className="AdminLayout__content">{children}</div>
      </div>
    </>
  );
};

export default AdminLayout;
